
import { toJS } from "mobx";
import * as APITypes from "constants/API";
import axios from "axios";

import AuthStore from "../../../../../src/modules/login/store/AuthStore";
import OptimizationStore from "../../../../modules/optimization/store/OptimizationStore"
import getCookie from "utils/journeyIdCookie/getJourneyId";
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "constants/Constants";
import fetchNeedMaster from "../../../../utils/fetchNeedMasterData"

const chooseProduct = async (selectedProduct) => {
    // let needList = AuthStore.needMasterList;
    let needList = await fetchNeedMaster()
    let recommendedProductData = toJS(OptimizationStore.recommendedProductData[0])
    let need = needList.find(
        (item) => item.unique_name == recommendedProductData.cardKey
    );
    
    let requestObj = {
        family_product_id: selectedProduct.family_product_id,
        new_target_amount: recommendedProductData.data.selected_sum_Assured,
        recommended_amount: recommendedProductData.data.recommended_sum_assured,
        user_journey_id: getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
        need_id: need.id,
        family_member_id: recommendedProductData.data.id,
        previous_product: recommendedProductData.data.package_id,
        new_product: selectedProduct.package_id,
        risk_type: recommendedProductData.data.selectedRisk || "high",
    };

    let chooseProductData = await axios.post(APITypes.CHANGE_PRODUCT_FOR_COMPARE, requestObj);

    let data = [toJS(OptimizationStore.recommendedProductData[0])]
    if (chooseProductData.data.need_title === "Protection for my Family") {

        let jsonOutputData = JSON.parse(chooseProductData?.data?.data[0]?.BI?.JsonOutput);
        let biData2 = [];
        if (
            jsonOutputData &&
            jsonOutputData.hasOwnProperty("BIJson2") &&
            jsonOutputData?.BIJson2
        ) {
            biData2 = JSON.parse(jsonOutputData.BIJson2);
        } else {
            biData2 = JSON.parse(jsonOutputData.BIJson);
        }
        
        if (jsonOutputData.Status === "Success") {
            data?.map((item) => {
                item.productName = chooseProductData.data.data[0].product_name
                item.data.bi_request = chooseProductData.data.data[0].bi_request
                item.data.biResponseCompleteData = biData2
                item.data.firstYearResponse = biData2[0]
                item.data.parsedResponse = biData2[biData2.length - 1]
                item.data.dob = chooseProductData.data.data[0].dob
                item.data.family_member_type = chooseProductData.data.data[0].family_member_type
                item.data.family_product_id = chooseProductData.data.data[0].family_product_id
                item.data.gender = chooseProductData.data.data[0].gender
                item.data.id = chooseProductData.data.data[0].id
                item.data.income_type = chooseProductData.data.data[0].income_type
                item.data.life_assured_details = chooseProductData.data.data[0].life_assured_details
                item.data.proposer_details = chooseProductData.data.data[0].proposer_details
                item.data.quotationId = chooseProductData.data.quotation_id
                item.data.package_id = chooseProductData.data.data[0].package_id
                item.data.product_id = chooseProductData.data.data[0].product_id
                item.data.product_name = chooseProductData.data.data[0].product_name
                item.data.payout_mode = chooseProductData.data.data[0].payout_mode
                // item.data.premium_message= chooseProductData.data.data[0].premium_message
                item.data.maximum_sum_assured = chooseProductData.data.data[0].maximum_sum_assured
                item.data.minimum_sum_assured = chooseProductData.data.data[0].minimum_sum_assured
                item.data.nudge_message = chooseProductData.data.data[0].nudge_message
                item.data.monthly_income = chooseProductData.data.data[0].monthly_income
                item.data.recommended_sum_assured = chooseProductData.data.data[0].recommended_sum_assured
                item.data.selected_sum_Assured = chooseProductData.data.data[0].selected_sum_Assured
                item.data.target_sa_more_than_reco_sa = chooseProductData.data.data[0].target_sa_more_than_reco_sa
            })
            OptimizationStore.setChooseProductData(data[0])
        } else {
            OptimizationStore.showErrorMsg(jsonOutputData);
        }
    } else {
        let jsonOutputData = JSON.parse(chooseProductData?.data?.data[0]?.BI[0]?.BI?.JsonOutput);
        let biData2 = [];
        if (
            jsonOutputData &&
            jsonOutputData.hasOwnProperty("BIJson2") &&
            jsonOutputData?.BIJson2
        ) {
            biData2 = JSON.parse(jsonOutputData.BIJson2);
        } else {
            biData2 = JSON.parse(jsonOutputData.BIJson);
        }
        if (jsonOutputData.Status === "Success") {
            data?.map((item) => {
                item.productName = chooseProductData.data.data[0].BI[0].product_name
                item.data.bi_request = chooseProductData.data.data[0].BI[0].bi_request
                item.data.biResponseCompleteData = biData2
                item.data.firstYearResponse = biData2[0]
                item.data.parsedResponse = biData2[biData2.length - 1]
                item.data.dob = chooseProductData.data.data[0].dob
                item.data.family_member_type = chooseProductData.data.data[0].family_member_type
                item.data.family_product_id = chooseProductData.data.data[0].BI[0].family_product_id
                item.data.gender = chooseProductData.data.data[0].gender
                item.data.id = chooseProductData.data.data[0].id
                item.data.income_type = chooseProductData.data.data[0].income_type
                item.data.life_assured_details = chooseProductData.data.data[0].life_assured_details
                item.data.proposer_details = chooseProductData.data.data[0].proposer_details
                item.data.quotationId = chooseProductData.data.quotation_id
                item.data.package_id = chooseProductData.data.data[0].BI[0].package_id
                item.data.product_id = chooseProductData.data.data[0].BI[0].product_id
                item.data.product_name = chooseProductData.data.data[0].BI[0].product_name
                item.data.payout_mode = chooseProductData.data.data[0].payout_mode
                // item.data.premium_message= chooseProductData.data.data[0].BI[0].premium_message
                item.data.maximum_sum_assured = chooseProductData.data.data[0].BI[0].maximum_sum_assured
                item.data.minimum_sum_assured = chooseProductData.data.data[0].BI[0].minimum_sum_assured
                item.data.nudge_message = chooseProductData.data.data[0].BI[0].nudge_message
                item.data.monthly_income = chooseProductData.data.data[0].monthly_income
                item.data.recommended_sum_assured = chooseProductData.data.data[0].BI[0].recommended_sum_assured
                item.data.selected_sum_Assured = chooseProductData.data.data[0].BI[0].selected_sum_Assured
                item.data.target_sa_more_than_reco_sa = chooseProductData.data.data[0].BI[0].target_sa_more_than_reco_sa
            })
            OptimizationStore.setChooseProductData(data[0])
        } else {
            OptimizationStore.showErrorMsg(jsonOutputData);
        }
    }
}
export default chooseProduct;